import { isElectron } from '@/utils/isElectron'

import type { CashMachineOptions, ICashMachine } from './types'

class CashGuardDirect implements ICashMachine {
  private ipcRenderer: any

  init({ port, inputAmountListener, totalAmountListener }: CashMachineOptions) {
    if (!isElectron) return
    this.ipcRenderer = window.require('electron').ipcRenderer
    this.ipcRenderer.on('cashguard:inputAmountUpdated', (_: unknown, amount: number) =>
      inputAmountListener(amount)
    )
    this.ipcRenderer.on('cashguard:totalAmountUpdated', (_: unknown, amount: number) =>
      totalAmountListener(amount)
    )
    return this.ipcRenderer.invoke('cashguard:init', port)
  }

  charge(amount: number) {
    return this.ipcRenderer.invoke('cashguard:charge', amount)
  }

  payIn(amount: number) {
    return this.ipcRenderer.invoke('cashguard:payIn', amount)
  }

  payOut(amount: number) {
    return this.ipcRenderer.invoke('cashguard:payOut', amount)
  }

  cancel() {
    return this.ipcRenderer.invoke('cashguard:cancel')
  }

  close() {
    return this.ipcRenderer.invoke('cashguard:close')
  }
}

export default new CashGuardDirect()
